import request from '@/utils/request'

export function downloadOneOrder(data) {
    return request({
        url: '/backend/order/downloadOneOrder',
        method: 'post',
        data: data
    })
}

export function downloadTimeZOrder(data) {
    return request({
        url: '/backend/order/downloadTimeZOrder',
        method: 'post',
        data: data
    })
}

export function presentRelationshipList(data) {
    return request({
        url: '/backend/common/orderPresent/getList',
        method: 'post',
        data: data
    })
}

export function presentRelationshipAdd(data) {
    return request({
        url: '/backend/common/orderPresent/add',
        method: 'post',
        data: data
    })
}

export function presentRelationshipDel(data) {
    return request({
        url: '/backend/common/orderPresent/delete',
        method: 'post',
        data: data
    })
}

export function presentRelationshipEdit(data) {
    return request({
        url: '/backend/common/orderPresent/edit',
        method: 'post',
        data: data
    })
}

export function mergeOrderADYUPNGXCJBS(data) {
    return request({
        url: '/backend/order/mergeOrderADYUPNGXCJBS',
        method: 'post',
        data: data
    })
}

//线下课分润列表
export function getCRMOrderBenefitList(data) {
    return request({
        url: '/backend/order/crm/getCRMOrderBenefitList',
        method: 'post',
        data: data
    })
}

//有多个手机号获取其他手机号归属列表
export function getFaceUniqueOtherUser(data) {
    return request({
        url: '/backend/order/crm/getFaceUniqueOtherUser',
        method: 'post',
        data: data
    })
}

//修改线下课分润审核记录其他手机号归属
export function setCRMOrderAgent(data) {
    return request({
        url: '/backend/order/crm/setCRMOrderAgent',
        method: 'post',
        data: data
    })
}


//设置备注
export function setCRMOrderRemark(data) {
    return request({
        url: '/backend/order/crm/setCRMOrderRemark',
        method: 'post',
        data: data
    })
}

//审核
export function approveCRMOrder(data) {
    return request({
        url: '/backend/order/crm/approveCRMOrder',
        method: 'post',
        data: data
    })
}

// 获取物流公司
export function getExpressRelation(data) {
    return request({
        url: '/backend/order/getExpressRelation',
        method: 'post',
        data: data
    })
}
export function getOrderExpress(data) {
    return request({
        url: '/backend/order/getOrderExpress',
        method: 'post',
        data: data
    })
}
export function saveOrderExpress(data) {
    return request({
        url: '/backend/order/saveOrderExpress',
        method: 'post',
        data: data
    })
}
export function sendOrderExpressSms(data) {
    return request({
        url: '/backend/order/sendOrderExpressSms',
        method: 'post',
        data: data
    })
}
export function orderCourseReplaceYJXWQZMQ(data) {
    return request({
        url: '/backend/order/orderCourseReplaceYJXWQZMQ',
        method: 'post',
        data: data
    })
}
export function orderFinishHYELEVEU(data) {
    return request({
        url: '/backend/order/orderFinishHYELEVEU',
        method: 'post',
        data: data
    })
}
export function orderShareBenefitRetakeHYELEVEU(data) {
    return request({
        url: '/backend/order/orderShareBenefitRetakeHYELEVEU',
        method: 'post',
        data: data
    })
}
export function orderJWStudentToCRMBenefit(data) {
    return request({
        url: '/backend/order/orderJWStudentToCRMBenefit',
        method: 'post',
        data: data
    })
}
export function userMergeKETRCHBLUK(data) {
    return request({
        url: '/backend/order/userMergeKETRCHBLUK',
        method: 'post',
        data: data
    })
}

export function getPsyItems(data) {//咨询师套餐包列表
    return request({
        url: '/backend/psy/item-package/list',
        method: 'post',
        data: data
    })
}